import React, { useContext } from "react";
import { LeftNavWrapper } from "./Styled";
import Section from "./Section";
import { LeftNavTab, LeftNavTabs } from "../../configs/leftNavTabs";
import { AuthenticationContext } from "../../provider/AuthenticationProvider";
import { canViewSidebarItem } from "../../configs/sidebarRoleAccess";

interface LeftNavProps {
    isCollapsed?: boolean;
}

const LeftNav = ({ isCollapsed }: LeftNavProps) => {
    const { user } = useContext(AuthenticationContext);
    const filteredTabs = LeftNavTabs.map((section) => ({
        ...section,
        tabList: section.tabList.filter((tab) =>
            canViewSidebarItem(user?.role, tab)
        ),
    })).filter((section) => section.tabList.length > 0);

    return (
        <LeftNavWrapper key="section" isCollapsed={isCollapsed}>
            {filteredTabs.map((leftNavTab: LeftNavTab) => (
                <Section
                    key={leftNavTab.title}
                    title={leftNavTab.title}
                    tabList={leftNavTab.tabList}
                    isCollapsed={isCollapsed}
                />
            ))}
        </LeftNavWrapper>
    );
};

export default LeftNav;
